(function (){
    'use strict';

    angular
        .module('services')
        .service('UserService', UserService)
    
    UserService.$inject = ['$http', 'API_BASE', 'jwtHelper'];

    function UserService($http, API_BASE, jwtHelper) {
        var service = this;

        service.all     = all;
        service.get     = get;
        service.remove  = remove;
        service.add     = add;
        service.save    = save;
        service.update  = update;

        function all () {
            return $http.get(API_BASE + '/users');
        }

        function get (id) {
            return $http.get(API_BASE + '/users/' + id);
        }

        function remove (id) {
            return $http.delete(API_BASE + '/users/' + id);
        }

        function add ( data) {
            return $http.put(API_BASE + '/users', data);
        }

        function save (data) {
            return $http.post(API_BASE + '/users', data);
        }

        function update (id, data) {
            return $http.put(API_BASE + '/users/' + id, data);
        }


    }
})();